function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ignoreError } from "../infra/utils";
export function logBIEvent(id, data) {
  var _window$debug;
  if ((_window$debug = window.debug) !== null && _window$debug !== void 0 && _window$debug.logbi) {
    // eslint-disable-next-line no-console
    console.log('BI', id, data);
  }
  ignoreError(() => {
    if (window._biHostname) {
      const blob = new Blob([JSON.stringify(_objectSpread({
        sessionId: window._sessionId,
        viewportHeight: window.innerHeight,
        viewportWidth: window.innerWidth
      }, data))], {
        type: 'application/json'
      });
      navigator.sendBeacon("".concat(window._biHostname, "/bi/").concat(id), blob);
    }
  });
}